import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrnamentCircles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 504,
	height: 255,
	viewBox: "0 0 504 255",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		opacity: .3,
		filter: "url(#filter0_d_564_3143)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M156 682C342.954 682 494.5 530.439 494.5 343.5C494.5 156.561 342.939 5 156 5C-30.9393 5 -182.5 156.561 -182.5 343.5C-182.5 446.242 -136.733 538.298 -64.4574 600.378M125.786 680.363L89.3806 677.178",
			stroke: "url(#paint0_linear_564_3143)",
			strokeWidth: 10,
			strokeMiterlimit: 10,
			shapeRendering: "crispEdges"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_564_3143",
		x: -191.5,
		y: 0,
		width: 695,
		height: 695,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_564_3143"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_564_3143",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_564_3143",
		x1: 473.554,
		y1: 481.011,
		x2: -158.678,
		y2: 199.523,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .2529,
			stopColor: "#79FBAF"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#79FBAF",
			stopOpacity: .1
		})]
	})] })]
});
export default SvgOrnamentCircles;
